import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class StrokeQualityMetricervice {

  passedFacility: string = '';
  pageTypeBool: boolean = false;
  standerdPassedFacility: string = '';
  standerdPageTypeBool: boolean = false;

  constructor(private http: HttpClient) { }

  GetStrokeQualityMetricCases(UID:any,roleName:any, obj: any) {
    return this.http.post(AUTH_API + `/Control/GetStrokeQualityMetricCases?userId=${UID}&roleName=${roleName}`, obj)
  }
//   GetQuarterDataFacility(id: any, date: any) {
//     return this.http.get(AUTH_API + `/facilities/GetFacilityGoals?facilityId=${id}&passingYear=${date}`)
//   }
//   AddQualityGoals(id: any, date: any, quater: any) {
//     var url = AUTH_API + `/facilities/CheckQualityGoalExist?facilities=${id}&timeframe=${date}&quater=${quater}`
//     return this.http.get(url)
//   }

GetFishBoneDiagramValues(UID:any,roleName:any, diagram: any, obj:any) {
  return this.http.post(AUTH_API + `/Control/GetFishBoneDiagramByFacility?userId=${UID}&roleName=${roleName}&cas_rcaDiagramOption=${diagram}`, obj);
}


}
